<div class="item">
  <div #mainTrigger>
    <div
      class="selected warp big"
      (click)="isSmartQuestion ? null : (isMainSelectOpen = true)"
    >
      <div class="w">
        <img src="/assets/images/types/{{ selectedType.image }}" class="img" />
        <p translate [translateParams]="{ type: selectedType }">
          menuTypes.name
        </p>
      </div>
      <img *ngIf="!isSmartQuestion" src="/assets/images/arrow-down.svg" />
      <div *ngIf="isSmartQuestion"></div>
    </div>
  </div>
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="mainTrigger"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayOpen]="true"
    cdkConnectedOverlayBackdropClass="backdrop-selection"
    (backdropClick)="isMainSelectOpen = false"
    [cdkConnectedOverlayOpen]="isMainSelectOpen"
    [cdkConnectedOverlayPositions]="positonArea"
  >
    <div class="menuSteps big">
      <div
        *ngFor="let type of types$ | async"
        class="op"
        (click)="updateMainSelection(type)"
      >
        <img src="/assets/images/types/{{ type.image }}" class="img" />
        <p translate [translateParams]="{ type: type }">menuTypes.name</p>
      </div>
    </div>
  </ng-template>
  <input
    class="title-input"
    placeholder="{{ 'questionBoard.edit.group.placeholder' | translate }}"
    [formControl]="modularQuestionForm.controls.title"
  />
  <div *ngIf="apiExposureFieldNameFill" class="input-with-image title-input">
    <input
      type="text"
      [formControl]="modularQuestionForm.controls.apiExposureFieldName"
      placeholder="{{
        'questionBoard.edit.group.fieldName-placeholder' | translate
      }}"
    />
  </div>
  <div #trigger>
    <div
      class="selected"
      (click)="isSmartQuestion ? null : (isSelectOpen = true)"
      *ngIf="
        this.modularQuestionForm.controls.type.value?.id ==
        eQuestionType.Autocomplete
      "
    >
      <p translate *ngIf="!selectedOptionName">
        questionBoard.edit.lists-placeholder
      </p>
      <p *ngIf="selectedOptionName">{{ selectedOptionName }}</p>
      <img *ngIf="!isSmartQuestion" src="/assets/images/arrow-down.svg" />
    </div>
  </div>
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayOpen]="true"
    cdkConnectedOverlayBackdropClass="backdrop-selection"
    (backdropClick)="isSelectOpen = false"
    [cdkConnectedOverlayOpen]="isSelectOpen"
    [cdkConnectedOverlayPositions]="positonArea"
  >
    <div class="menuSteps">
      <div *ngFor="let op of allOptionLists$ | async" class="op">
        <p translate (click)="updateSelection(op)">
          {{ op.name }}
        </p>
      </div>
    </div>
  </ng-template>

  <img
    class="remove-btn"
    *ngIf="!isOnly && !isSmartQuestion"
    (click)="delete()"
    src="/assets/images/close.svg"
  />
</div>
